import {
	VStack,
	Text,
	HStack,
	Button,
	StackDivider,
	Link,
	useDisclosure,
	Drawer,
	DrawerBody,
	DrawerCloseButton,
	DrawerContent,
	DrawerOverlay,
} from "@chakra-ui/react";
import { useState } from "react";
import { Link as RouterLink } from "react-router-dom";
import ConsultantMiniProfile from "@components/createOrder/ConsultantMiniProfile";

interface Props {
	duration: string;
	description: string;
	consultantData?: { firstName: string; id: string; hasWorked?: boolean };
	jobData?: { label: string; url: string };
}

const ShiftToolTip = ({ duration, description, consultantData, jobData }: Props) => {
	// consultantDataList & jobData can't be there at the same time for a particular shift
	const [selectedConsultantToPreview, setSelectedConsultantToPreview] = useState<{
		firstName: string;
		id: string;
		hasWorked?: boolean;
	} | null>();

	const { isOpen, onOpen, onClose } = useDisclosure();

	return (
		<VStack bg={"#FFFFFF"} color={"#353535"} alignItems={"flex-start"} gap={"5px"}>
			<Text textTransform={"capitalize"} m={0} fontWeight={500} fontSize={"14px"}>
				{duration}
			</Text>
			<Text m={0} fontWeight={500} fontSize={"12px"} color={"#9a9a9a"}>
				{description}
			</Text>
			{consultantData && (
				<HStack>
					<Text m={0} fontWeight={500} fontSize={"12px"}>
						{"Konsult: "}
					</Text>
					<HStack divider={<StackDivider borderColor="linkedin.200" />}>
						<Button
							size={"xs"}
							colorScheme="linkedin"
							variant="link"
							onClick={() => {
								onOpen();
								setSelectedConsultantToPreview(consultantData);
							}}
						>
							{consultantData.firstName}
						</Button>
					</HStack>
				</HStack>
			)}
			{jobData && (
				<HStack>
					<Text m={0} fontWeight={500} fontSize={"12px"}>
						{"Uppdrag: "}
					</Text>
					<Link as={RouterLink} to={jobData.url}>
						<Text
							m="0"
							cursor={"pointer"}
							_hover={{ textDecoration: "underline" }}
							color={"#219CD0"}
							fontSize={"12px"}
							fontWeight={500}
						>
							{jobData.label}
						</Text>
					</Link>
				</HStack>
			)}
			{/* consultant profile drawer */}
			<Drawer
				placement={"right"}
				size={"sm"}
				onClose={() => {
					onClose();
					setSelectedConsultantToPreview(null);
				}}
				isOpen={isOpen}
			>
				<DrawerOverlay />
				<DrawerContent borderLeftRadius={"25px"}>
					<DrawerCloseButton
						onClick={() => {
							onClose();
							setSelectedConsultantToPreview(null);
						}}
					/>
					<DrawerBody p={6}>
						{selectedConsultantToPreview && (
							<ConsultantMiniProfile
								id={selectedConsultantToPreview.id}
								previouslyHired={selectedConsultantToPreview.hasWorked ? true : false}
							/>
						)}
					</DrawerBody>
				</DrawerContent>
			</Drawer>
		</VStack>
	);
};

export default ShiftToolTip;
